<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 font-45 colorPrincipal">
            PENSADORAS <br> PERUANAS <br>
            <span class="fontMS300">
                DEL SIGLO XIX <br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio10/pensadoresXIX">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio10/pensadoresXIX">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio10/pensadoresXIX">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img001.jpg">
</section>
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center  font-24">
                    LAS PENSADORAS PERUANAS DEL SIGLO XIX SON PIONERAS EN MUCHOS SENTIDOS DE LA PALABRA. DESAFÍAN LA 
                    SUBORDINACIÓN DEL LLAMADO «BELLO SEXO» E INCURSIONAN EN ESPACIOS ANTES RESERVADOS PARA LOS HOMBRES. 
                    INICIAN LA LUCHAN POR EL DERECHO DE ESTUDIAR EN LA UNIVERSIDAD. TAMBIÉN ABOGAN POR UNA EDUCACIÓN DE CALIDAD 
                    PARA LAS NIÑAS Y ADOLESCENTES DEL PAÍS. SON DOCENTES, PERIODISTAS, ESCRITORAS, ABOGADAS, MÉDICAS Y NEGOCIANTES. 
                    DIRIGEN MEDIOS PERIODÍSTICOS. TAMBIÉN FUNDAN VELADAS LITERARIAS, REVISTAS, ESCUELAS E IMPRENTAS. 
                    <br>
                </p>
                <p class="fontMS100 text-justify  font-24 text-gris">
                    <br>
                    Esta generación de mujeres ilustradas representa un hito para la historia de la mujer en el Perú. 
                    Las obras de estas pensadoras revelan la inquietud social y literaria a finales del siglo XIX. 
                    A través de sus novelas, cuentos, leyendas, tradiciones, crónicas, ensayos y poesía también piensan 
                    en el futuro del país. Hablan de tecnología, trabajo y economía. Indagan en el tema de la identidad 
                    y la reconstrucción nacional. Denuncian la injusticia y la desigualdad. Finalmente, algunas de ellas 
                    manifiestan críticas mordaces de la codicia, la corrupción y la mediocridad. Pero su audacia tendrá 
                    graves consecuencias. Escritoras como Mercedes Cabello de Carbonera y Clorinda Matto de Turner fueron 
                    blanco de ataques, censuras y calumnias. Pero estas pensadoras nunca se rindieron. Se reinventaron una 
                    y otra vez, y las obras que han dejado para la posteridad son prueba de su persistencia. 
                    <br>
                </p>
                <br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br><br><br><br>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            LAS VELADAS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal  font-40">
                    LITERARIAS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada.png">
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500  font-24">
                            <br>
                            LA ESCRITORA ARGENTINA JUANA MANUELA GORRITI ESTÁ EN LA CIMA DE SU TRAYECTORIA LITERARIA 
                            CUANDO EMPIEZA A ORGANIZAR SUS FAMOSAS VELADAS LITERARIAS. ENTRE 1876 Y 1877 LOS PRINCIPALES 
                            ESCRITORES, POLÍTICOS Y PENSADORES SE JUNTARÁN EN SU CASA EN EL CENTRO DE LIMA PARA HACER 
                            DECLAMACIONES, DAR RECITALES MUSICALES Y DEBATIR TEMAS DE RELEVANCIA SOCIAL. 
                        </p>
                        <div class="row p-5">
                            <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img002.jpg">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify p3 font-24">
                            Las veladas literarias de Juana Manuela Gorriti desafían la división entre lo privado y lo 
                            público. Fomentan el debate intelectual dentro del ámbito doméstico mientras acogen a todos 
                            los familiares. Incluso participan los hijos e hijas de los asistentes a través 
                            de charadas programadas.
                            <br><br>
                            Es dentro de este espacio que jóvenes escritoras como Teresa González de Fanning, Mercedes 
                            Cabello de Carbonera y Clorinda Matto de Turner presentan sus primeras obras 
                            e introducen nuevos temas de discusión, como la educación de la mujer.
                        </p>
                        <div class="row">
                            <div class="col-sm-10">
                                <p class="fontMS700 font-24">
                                    <br><br>
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                                    <a href="https://hdl.handle.net/20.500.14428/72375"
                                        target="_blank" style="color: black;">
                                        <i class="fas fa-file-alt  font-24 p-3"></i>
                                        JUANA MANUELA GORRITI. <br>
                                    </a>
                                    <span class="fontMS300Italic">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        Veladas literarias de Lima.<br>
                                    </span>
                                    <span class="fontMS300">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        Imprenta Europea, 1892.
                                    </span>
                                    <br>
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Azul_Img">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada2.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 140%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA EDUCACIÓN FEMENINA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada2.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-center font-24 text-white">
                    <br>
                    EN EL SIGLO XIX LA EDUCACIÓN PARA LAS MUJERES ERA BÁSICA Y LIMITADA, DIRIGIDA CASI EXCLUSIVAMENTE A 
                    SUS FUTUROS ROLES COMO MADRES Y ESPOSAS. 
                </p>
                <p class="fontMS100 text-justify  font-24 text-white">
                    <br>
                    La escritora y docente Teresa González de Fanning sugiere que este tipo de formación solo ofrece 
                    dos caminos para las mujeres: el matrimonio o el claustro. Ella aboga por una educación 
                    comprehensiva que ayude a las mujeres a realizarse como personas, y a trabajar y mantenerse si es 
                    necesario. Teresa González de Fanning sabe de primera mano la situación de vulnerabilidad y 
                    dependencia en la que se encuentra la mujer del siglo XIX. Como muchas mujeres peruanas, queda viuda 
                    durante la Guerra del Pacífico y tiene que buscarse la vida. 
                    En medio de la guerra funda un colegio para señoritas donde además puede poner en práctica sus 
                    ideas sobre la educación femenina.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/79626" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img003.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/79198" target="_blank">

                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img004.jpg">

                        </a>
                    </div>
                    <div class="col-sm-4">
                        <a href="https://hdl.handle.net/20.500.14428/6678" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img005.jpg">
                        </a>
                    </div>
                </div>
                <br><br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br><br><br>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;margin-top: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            LAS PRIMERAS UNIVERSITARIAS
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada3.png">
                    </div>
                </div>
                <p class="fontMS500 text-center  font-24 text-white">
                    <br>
                    LA LUCHA POR LA EDUCACIÓN FEMENINA LLEGA HASTA LOS NIVELES MÁS ALTOS DE ESTUDIO. DURANTE LAS ÚLTIMAS 
                    DÉCADAS DEL SIGLO XIX DIECISIETE INTRÉPIDAS MUJERES PERSEVERAN HASTA SER ADMITIDAS A LOS ESTUDIOS 
                    UNIVERSITARIOS. 
                </p>
                <p class="fontMS100 text-justify  font-24 text-white">
                    <br>
                    Para lograr ser parte de la vida universitaria deben solicitar autorización del presidente de la nación 
                    y dar exámenes rigurosos en todo tipo de materias para demostrar que tienen una buena formación secundaria. 
                    Incluso cuando logran entrar a la universidad y culminar sus estudios de manera satisfactoria, muchas 
                    enfrentan dificultades para ejercer su profesión, sobre todo si era una disciplina dominada por los hombres.
                    <br><br>
                    Gracias a la defensa de la educación femenina impulsada por las escritoras ilustradas y la 
                    tenacidad de las primeras universitarias, en el año 1908, todas las mujeres peruanas ganaron el 
                    derecho de ingresar a la universidad, optar por títulos académicos y ejercer su profesión sin 
                    reservas. 
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <a href="https://hdl.handle.net/20.500.14428/71611" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img006.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4">
                        <a href="https://hdl.handle.net/20.500.14428/71772" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img007.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4">
                        <a href="https://hdl.handle.net/20.500.14428/29511" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img009.jpg">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Gris_Img">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada2.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;margin-top:0%"
                            class="fontMS700 text-center colorPrincipal font-38">
                            LITERATURA Y CRÍTICA SOCIAL
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada2.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-center  font-24">
                    <br>
                    LAS OBRAS LITERARIAS DE MUCHAS DE ESTAS PENSADORAS ESTÁN MARCADAS POR UNA FUERTE CRÍTICA SOCIAL. A 
                    TRAVÉS DE TEMAS SENTIMENTALES COMO EL MATRIMONIO POR CONVENIENCIA, REVELAN LA SITUACIÓN DE 
                    VULNERABILIDAD Y SUBORDINACIÓN QUE ENFRENTABAN LAS MUJERES EN EL SIGLO XIX. 
                </p>
                <p class="fontMS100 text-justify  font-24">
                    <br>
                    Sus críticas también van más allá del hogar familiar. Abordan temas como los abusos del clero, 
                    la marginación de los indígenas, la corrupción y la codicia. Uno de los casos más emblemáticos es 
                    el de Mercedes Cabello de Carbonera. En las novelas <span class="fontMS100Italic">Blanca sol </span>o 
                    <span class="fontMS100Italic">Las consecuencias,</span> usa temas sentimentales para revelar la 
                    situación de la mujer y enjuiciar a la élite del país. En <span class="fontMS100Italic">El conspirador</span> 
                    también ofrece un retrato mordaz de la sociedad de posguerra, pero esta vez a 
                    partir del dramático ascenso y caída de un joven militar. Finalmente, en el campo ensayístico revela su 
                    interés en el positivismo, la función social de la literatura y la creación de una mejor sociedad. 
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79627" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img010.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://hdl.handle.net/20.500.14428/71766" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img011.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://hdl.handle.net/20.500.14428/71757" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img012.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://hdl.handle.net/20.500.14428/45573" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img013.jpg">
                        </a>
                    </div>
                </div>
                <!--Línea de separación-->
                <br><br><br><br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br><br><br><br>
                <!--Línea de separación-->
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada2.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL AUGE DEL PERIODISMO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 text-center colorPrincipal  font-40">
                    FEMENINO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada.png">
                </div>
                <p class="fontMS500 text-center  font-24">
                    <br>
                    PARA LAS ESCRITORAS DECIMONÓNICAS, LA PRENSA ES UN ESPACIO SUMAMENTE IMPORTANTE. MUCHAS VECES, ES EL
                    PRIMER MEDIO DONDE PUEDEN DIFUNDIR SUS OBRAS LITERARIAS, SEAN NOVELAS POR ENTREGAS, POESÍA,
                    TRADICIONES O LEYENDAS. 
                    ALLÍ TAMBIÉN DAN A CONOCER SUS IDEAS SOBRE CIENCIA, FILOSOFÍA, EDUCACIÓN, POLÍTICA Y ECONOMÍA. 
                    <br>
                </p>

                <p class="fontMS100 text-justify font-24">
                    <br>
                    En 1872, aparece <span class="fontMS100Italic">La Bella Limeña</span>, el primer periódico dirigido
                    a las mujeres de la capital. A pesar de su corta vida, esta publicación provoca un verdadero <span
                    class="fontMS100Italic">boom</span> del periodismo femenino. Surgen nuevos medios escritos por y para mujeres,
                    como <span class="fontMS100Italic">El Álbum</span> (1874-1875), dirigido por Carolina Freyre y Juana 
                    Manuela Gorriti, y <span class="fontMS100Italic">La Alborada</span> (1874-1875), también fundado por Gorriti.
                    Clorinda Matto de Turner, por su parte, dirigió diversos medios para todo tipo de público: 
                    <span class="fontMS100Italic">El Recreo</span> de Cusco (1876-1877), <span
                    class="fontMS100Italic">La Bolsa</span> de Arequipa (1884-1885), 
                    <span class="fontMS100Italic">El Perú Ilustrado</span> (1889-1891) y 
                    <span class="fontMS100Italic">Los Andes</span> (1893-1895). 
                    Al tomar el mando de la dirección, estas periodistas tuvieron la oportunidad de 
                    definir el discurso público y dar espacio a nuevas voces. 
                    <br><br>
                </p>
                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-3">
                        <p><br></p>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://hdl.handle.net/20.500.14428/73301" target="_blank" style="color: black;">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img017.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3 libro">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-bella-limena-periodico-semanal-para-las-familias/3/"
                            target="_blank" style="color: black;">
                            <img width="100%" class="img-fluid"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img018.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Carolina Freyre de Jaimes.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Un amor desgraciado.
                                        <br>
                                    </span>
                                    La Bella Limeña, no. 4, 1872.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <p><br></p>
                    </div>
                </div>
                <br><br>
                <!--TABLET-->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a [routerLink]="['/ficha/PER-96']" target="_blank" style="color: black;">
                                <img class="p2" width="100%"
                                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img017.jpg">
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/la-bella-limena-periodico-semanal-para-las-familias/3/"
                                target="_blank" style="color: black;">
                                <img width="100%" class="img-fluid"
                                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img018.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Carolina Freyre de Jaimes.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Un amor desgraciado.
                                            <br>
                                        </span>
                                        La Bella Limeña, no. 4, 1872.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-3">
                        <a href="https://hdl.handle.net/20.500.14428/70117" target="_blank" style="color: black;">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img019.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79644"
                            target="_blank" style="color: black;">
                            <img class="p2 img-fluid" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img020.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Trinidad M. Enríquez.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Mosaico.
                                        <br>
                                    </span>
                                    El Recreo, Año I, no. 6, 1876.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79645"
                            target="_blank" style="color: black;">
                            <img class="p2 img-fluid" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img021.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Clorinda Matto de Turner.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Zelenque.
                                        <br>
                                    </span>
                                    El Recreo, Año I, no. 7, 1876.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/el-recreo/71/"
                            target="_blank" style="color: black;">
                            <img class="p2 img-fluid" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img022.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Juana Manuela Gorriti.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        El tesoro de los incas.
                                        <br>
                                    </span>
                                    El Recreo, Año I, no. 9, 1876.
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <br><br>
                <!--TABLET-->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 tab">
                            <a href="http://hdl.handle.net/20.500.14428/79646" target="_blank" style="color: black;">
                                <img class="p2" width="100%"
                                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img019.jpg">
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="http://hdl.handle.net/20.500.14428/79644"
                                target="_blank" style="color: black;">
                                <img class="p2 img-fluid" width="100%"
                                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img020.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Trinidad M. Enríquez.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Mosaico.
                                            <br>
                                        </span>
                                        El Recreo, Año I, no. 6, 1876.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="http://hdl.handle.net/20.500.14428/79645"
                                target="_blank" style="color: black;">
                                <img class="p2 img-fluid" width="100%"
                                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img021.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Clorinda Matto de Turner.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Zelenque.
                                            <br>
                                        </span>
                                        El Recreo, Año I, no. 7, 1876.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/el-recreo/71/"
                                target="_blank" style="color: black;">
                                <img class="p2 img-fluid" width="100%"
                                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img022.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Juana Manuela Gorriti.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            El tesoro de los incas.
                                            <br>
                                        </span>
                                        El Recreo, Año I, no. 9, 1876.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79059" target="_blank" style="color: black;">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img023.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3 libro">
                        <a href="https://hdl.handle.net/20.500.14428/70117" target="_blank" style="color: black;">
                            <img class="p2 img-fluid" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img024.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Teresa González de Fanning.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        La cita en el cielo.
                                        <br>
                                    </span>
                                    EPI, Año II, semestre II, no. 83, 1888.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79624" target="_blank" style="color: black;">
                            <img class="p2 img-fluid" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img025.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Mercedes Cabello de Carbonera.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Un capítulo de Blanca sol.
                                        <br>
                                    </span>
                                    EPI, Año II, semestre II, no. 91, 1889.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79625" target="_blank" style="color: black;">
                            <img class="p2 img-fluid" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img026.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Amalia Puga.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        28 de julio.
                                        <br>
                                    </span>
                                    EPI, Año III, semestre I, n. 116, 1889.
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <!--TABLET-->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 tab">
                            <a href="http://hdl.handle.net/20.500.14428/79059" target="_blank" style="color: black;">
                                <img class="p2" width="100%"
                                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img023.jpg">
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://hdl.handle.net/20.500.14428/70117" target="_blank" style="color: black;">
                                <img class="p2 img-fluid" width="100%"
                                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img024.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Teresa González de Fanning.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            La cita en el cielo.
                                            <br>
                                        </span>
                                        EPI, Año II, semestre II, no. 83, 1888.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="http://hdl.handle.net/20.500.14428/79624" target="_blank" style="color: black;">
                                <img class="p2 img-fluid" width="100%"
                                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img025.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Mercedes Cabello de Carbonera.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Un capítulo de Blanca sol.
                                            <br>
                                        </span>
                                        EPI, Año II, semestre II, no. 91, 1889.
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="http://hdl.handle.net/20.500.14428/79625" target="_blank" style="color: black;">
                                <img class="p2 img-fluid" width="100%"
                                    src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img026.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            Amalia Puga.
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            28 de julio.
                                            <br>
                                        </span>
                                        EPI, Año III, semestre I, n. 116, 1889.
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Azul">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img width="100%" src="\assets\images\general\LINEA_RESALTE_BLANCA.png">
                <br><br>
                <p class="fontMS500 text-white text-justify  font-24">
                    ESTAS PIONERAS TUVIERON QUE AFRONTAR FURIBUNDOS ATAQUES QUE PROVENÍAN DE LOS GRUPOS DE PODER
                    ECONÓMICO, POLÍTICO Y PATRIARCAL POR ATREVERSE A QUEBRANTAR EL ORDEN SOCIAL. ELLAS LUCHARON POR SU
                    AUTONOMÍA Y LA DE LOS MEDIOS DE COMUNICACIÓN QUE FUNDARON, OSCILARON ENTRE LA CIUDAD LETRADA Y LA
                    CIUDAD REAL, NO PERMITIERON SOMETERSE AL SENSACIONALISMO, DEFENDIERON LA LIBERTAD DE EXPRESIÓN, LOS
                    DERECHOS CIVILES, LA EDUCACIÓN DE LAS MUJERES Y DE TODA LA POBLACIÓN. <br>
                </p>
                <div class="col-sm-12 text-right mt-3 mb-3">
                    <span class="fontMS300Italic text-white  font-24">CAROLINA ORTIZ FERNÁNDEZ, 2018.</span>
                </div>
                <img id="img_rotate" src="\assets\images\general\LINEA_RESALTE_BLANCA.png">
            </div>
        </div>
    </div>
</div>
<div class="container_Gris_Img2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;margin-top: 1%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            CORRESPONDENCIA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS300 text-center colorPrincipal  font-40">
                    CON RICARDO PALMA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada.png">
                </div>
                <p class="fontMS500 text-center  font-24">
                    <br>
                    EN EL AÑO 2020 MÁS DE 400 CARTAS DE LA COLECCIÓN RICARDO PALMA SORIANO FUERON DECLARADAS PATRIMONIO
                    CULTURAL DE LA NACIÓN. DENTRO DE ESTA EXTENSA COLECCIÓN SE DESTACA SU INTENSA CORRESPONDENCIA CON
                    LAS ESCRITORAS MÁS IMPORTANTES DEL PERÚ, SUDAMÉRICA Y EL CARIBE A FINALES DEL SIGLO XIX.
                    <br><br>
                </p>
                <div class="row text-center">
                    <div class="col-sm-3">
                        <p><br></p>
                    </div>
                    <div class="col-sm-6">
                        <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img027.jpg">
                    </div>
                    <div class="col-sm-3">
                        <p><br></p>
                    </div>
                </div>
                <p class="fontMS100 text-justify  font-24">
                    <br><br>
                    Durante más de dos décadas, el autor de las
                    <span class="fontMS100Italic">Tradiciones peruanas</span>
                    mantiene una comunicación constante y directa, personal y profesional con escritoras como Juana 
                    Manuela Gorriti, Teresa González de Fanning, Clorinda Matto de Turner, Amalia Puga y Mercedes 
                    Cabello de Carbonera, entre otras. 
                    <br><br>
                    Las cartas seleccionadas ofrecen una mirada íntima de la experiencia de ser escritora a finales del 
                    siglo XIX. En cuanto a lo literario, hay mención de libros prestados y lecturas compartidas con el 
                    escritor consagrado. Le comentan nuevos proyectos y le piden consejos y juicios críticos. Del mismo 
                    modo aparece información sobre su vida diaria. Hablan de sus hijos, sus viajes y achaques. Surge el 
                    tema del trabajo renumerado. Hablan de la docencia y el periodismo. Finalmente, las cartas de 
                    Mercedes Cabello de Carbonera dan indicios de las persecuciones que experimenta al final de su vida. 
                    <br>
                </p>
                <br><br>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS300 text-center font-24">
                            JUANA MANUELA GORRITI
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <p>
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3">
                        <a href="https://hdl.handle.net/20.500.14428/34081" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img028.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://hdl.handle.net/20.500.14428/34526" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img029.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://hdl.handle.net/20.500.14428/34559" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img030.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://hdl.handle.net/20.500.14428/36389" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img031.jpg">
                        </a>
                    </div>
                </div>
                <p>
                    <br><br><br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS300 text-center font-24">
                            TERESA GONZÁLEZ DE FANNING
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <p>
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-4 p-5">
                        <a href="https://hdl.handle.net/20.500.14428/25482" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img032.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 p-5">
                        <a href="https://hdl.handle.net/20.500.14428/17836" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img033.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 p-5">
                        <a href="https://hdl.handle.net/20.500.14428/17841" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img034.jpg">
                        </a>
                    </div>
                </div>
                <p>
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS300 text-center font-24">
                            MERCEDES CABELLO DE CARBONERA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <p>
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-4 p-5">
                        <a href="https://hdl.handle.net/20.500.14428/34053" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img035.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 p-5">
                        <a href="https://hdl.handle.net/20.500.14428/34088" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img036.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4 p-5">
                        <a href="https://hdl.handle.net/20.500.14428/15917" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img037.jpg">
                        </a>
                    </div>
                </div>
                <p>
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS300 text-center  font-24">
                            AMALIA PUGA DE LOSADA
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <p>
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3">
                        <p><br></p>
                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79285" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img038.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://hdl.handle.net/20.500.14428/70035" target="_blank">
                            <img class="p2" width="100%"
                                src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA_img039.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <p><br></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container_Rosado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <!-- <div class="col-sm-4">
                        <img class="img-fluid mb-3 pointer" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img008c.jpg">
                    </div> -->
                    <div class="col-sm-12">
                        <p class="text-white fontMS500 font-24">
                            Para la primera generación de mujeres ilustradas la educación es fundamental. Piden acceso a
                            una educación de calidad para mejorar la condición de las mujeres y contribuir al progreso
                            de la Nación.

                        </p>
                    </div>
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            Imagina un día de colegio en 1890. ¿Quién asiste? ¿Cómo es la instrucción? ¿Qué materias se
                            enseñan?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Crees que se ha logrado paridad de género en la educación? Te invitamos a investigar sobre
                            el tema, teniendo en cuenta diversas disciplinas y todos los niveles educativos.

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            Después de revisar la correspondencia, ¿cuál fue el rol de Ricardo Palma para esta
                            generación de pensadoras peruanas?, ¿cómo caracterizarías su vínculo con ellas?

                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 120%;margin-bottom: 0%;margin-top: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA1-recortada3.png">
                    </div>
                </div>
                <p class="fontMS100  font-24">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100  font-24">
                            <span class="fontMS500">
                                Batticuore, G.A. (2016).
                            </span>
                            <br>
                            <span class="fontMS100Italic">
                                La vida en las cartas. Ricardo Palma entre
                                escritoras. <br>
                            </span>
                            En: Aula Palma. Revista del Instituto Ricardo Palma XV (15): 253-274.<br>
                            <a href="https://core.ac.uk/reader/323513590" target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <br>
                        <p class="fontMS100  font-24">
                            <span class="fontMS500">
                                Denegri, F. (1996).
                            </span>
                            <br>
                            <span class="fontMS100Italic">
                                El abanico y la cigarrera: La primera
                                generación de mujeres ilustradas en el Perú.
                            </span>
                            Lima: IEP; CMP Flora Tristán. <br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=229852 " target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <br>
                        <p class="fontMS100  font-24">
                            <span class="fontMS500">
                                Guardia, S.B. (ed.) (2012).
                            </span>
                            <br>
                            <span class="fontMS100Italic">
                                Escritoras del siglo XIX en América Latina.
                            </span>
                            Lima: CEMHAL. <br>
                            <a href="http://www.cemhal.org/Escritoras%20del%20siglo%20XIX.pdf" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <br>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100  font-24">
                            <span class="fontMS500">
                                Huarcaya Gutiérrez, E. (2020).
                            </span>
                            <br>
                            <span class="fontMS100Italic">
                                El ensayo escrito por mujeres en el Perú decimonónico (1882-1892).
                            </span>
                            Tesis para optar el título de Licenciada en Literatura. UNMSM. <br>
                            <a href="https://cybertesis.unmsm.edu.pe/bitstream/handle/20.500.12672/11731/Huarcaya_ge.pdf?sequence=1&isAllowed=y"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <br>
                        <p class="fontMS100  font-24">
                            <span class="fontMS500">
                                Ortiz Fernández, C. (2018).
                            </span>
                            <br>
                            <span class="fontMS100Italic">
                                El Recreo, tribuna pública de mujeres pioneras en la educación y el periodismo en el
                                Perú del siglo XIX.
                            </span>
                            En: Letras 89(130): 100-122. <br>
                            <a href="http://www.scielo.org.pe/scielo.php?script=sci_arttext&pid=S2071-50722018000200005&lng=es&nrm=iso&tlng=es"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <br>
                        <p class="fontMS100  font-24">
                            <span class="fontMS500">
                                Velázquez, M. (ed.) (2009).
                            </span>
                            <br>
                            <span class="fontMS100Italic">
                                La república de papel. Política e imaginación
                                social en la prensa peruana del siglo XIX.
                            </span>
                            Lima: Fondo editorial UCH. <br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=373004" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>